import React from 'react';
import { TransformCTA } from '../TransformCTA';
import { volumes } from '../../data/content';
export function Volumes() {
  return <section className="w-full bg-bone-50 px-5 py-14 sm:py-20" data-id="element-223" data-mp="320w9gs20tyky">
      <div className="mx-auto w-full max-w-xl lg:max-w-5xl" data-id="element-224" data-mp="2x0qlpmyvgw85">
        <h2 className="text-center font-display text-[26px] font-bold leading-tight text-ink-900 sm:text-[34px]" data-id="element-225" data-mp="2x34ic097aght">
          What is included in the Male Fertility Route?
        </h2>
        <p className="mx-auto mt-4 max-w-lg text-center text-[15px] leading-relaxed text-ink-900/60 sm:text-base" data-id="element-226" data-mp="2o1wlznq8vpqd">
          6 digital volumes that guide you from the first consultation to case resolution.
        </p>

        <ol className="mt-10 space-y-4 lg:grid lg:grid-cols-2 lg:gap-5 lg:space-y-0" data-id="element-227" data-mp="2e8fp2aut9uih">
          {volumes.map(volume => <li key={volume.roman} className="rounded-2xl border border-bone-200 bg-white p-5 shadow-card sm:p-6" data-id="element-228" data-mp="25alwnb063l0l">
              <div className="flex items-center gap-2" data-id="element-229" data-mp="20d3woa44og4q">
                <span className="rounded-md bg-ink-900 px-2 py-1 text-[10px] font-extrabold uppercase tracking-[0.16em] text-teal-300" data-id="element-230" data-mp="335e4bpukjsel">
                  {volume.roman}
                </span>
              </div>
              <h3 className="mt-3 font-display text-[21px] font-bold leading-tight text-ink-900 sm:text-2xl" data-id="element-231" data-mp="2u693gcvjbmz9">
                {volume.title}
              </h3>
              <p className="mt-2 text-[14px] font-semibold leading-snug text-teal-700 sm:text-[15px]" data-id="element-232" data-mp="3lwdjjzc9hnuo">
                {volume.hook}
              </p>
              <p className="mt-3 text-[14px] leading-relaxed text-ink-900/65 sm:text-[15px]" data-id="element-233" data-mp="3quou6cads2dy">
                {volume.body}
              </p>
            </li>)}
        </ol>

        <TransformCTA tone="light" headline="Access all 6 volumes today and approach your next case with greater clinical judgment." data-id="element-234" data-mp="3hthaaz8m343e" />
      </div>
    </section>;
}